import { toCamelCase } from "./toCamelCase";

export const getInputTestIdByName = (name?: string) => {
  if (!name) {
    return undefined;
  }

  return toCamelCase(name, "field");
};
